import React from 'react';
import { Tooltip } from 'antd';
import './AdminCopilotResults.less';
import { ContentObject } from '../../interfaces/copilotChat';
import { CopyOutlined, CloseOutlined } from '@ant-design/icons';
import { Notify } from '../../services/notificationService';
import { useAgentSelector } from '../../hooks/useAgentStore';
import { getArtifactContent } from '../../utils/artifactUtils';
import CustomChatItem from '../AdminCopilotChat/ChatItem';

interface Props {
  onClose: () => void;
}

const AdminCopilotResults: React.FC<Props> = ({ onClose }) => {
  const { result: results } = useAgentSelector((state) => state.adminAgent);

  const copyResults = () => {
    const markdownContent =
      results
        ?.map((result) => {
          let content = result.text;
          if (result.code) {
            content +=
              '\n\n' +
              result.code
                .map(
                  (code) =>
                    `\`\`\`${code.name.split('.').pop() || 'text'}\n${code.contents}\n\`\`\``
                )
                .join('\n\n');
          }
          return content;
        })
        .join('\n\n---\n\n') ?? '';

    navigator.clipboard.writeText(markdownContent);
    Notify.success('Copied to clipboard');
  };

  const renderResult = (result: ContentObject, index: number) => {
    return (
      <div key={index} className="result-item">
        <CustomChatItem message={getArtifactContent(result)} />
      </div>
    );
  };

  return (
    <div id="admin-agent-results">
      <div className="chat-results">
        <div className="results-header">
          <div className="results-header-left">
            <h3>{results?.[0]?.title ?? 'Artifact'}</h3>
          </div>
          <div className="results-header-right">
            <Tooltip title="Copy">
              <div className="header-action" onClick={copyResults}>
                <CopyOutlined />
              </div>
            </Tooltip>
            <Tooltip title="Close">
              <div className="header-action" onClick={onClose}>
                <CloseOutlined />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="results-content">
          {results && results.length > 0
            ? results.map((result, index) => renderResult(result, index))
            : null}
        </div>
      </div>
    </div>
  );
};

export default AdminCopilotResults;
